// LivestreamDetailOnlineFooter.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import LivestreamDetailOnlineFooter from '../component/LivestreamDetailOnlineFooter.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import checkLivestreamChatPreflightAndOpenPanel from '../action/checkLivestreamChatPreflightAndOpenPanel.js';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import toggleModal from '../action/toggleModal.js';
import addModal from '../action/addModal.js';
import login from '../action/login.js';

import { PRESET_SD } from '../resource/liveStreamConstants.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import { BLUROUT_PARAMETERS, FEATURE_GAMES } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const isAuthed = !!getMeData(state, 'id');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  const previewBlurManifest = getRemoteConfigData(
    state,
    BLUROUT_PARAMETERS
  )?.[2];
  const isStreamPreviewBlurEnabled = !!previewBlurManifest;
  const shouldDisplayBlurCountdown =
    isStreamPreviewBlurEnabled && streamStatus === PRESET_SD && !hasStreamToken;

  return {
    isAuthed,
    isStreamer: meId != null && meId === streamId,
    streamStatus,
    isChatPanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isChatPanelOpen'
    ),
    isGamePanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isGamePanelOpen'
    ),
    isSuperChatOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isSuperChatOpen'
    ),
    isTriggerPrivatePanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isTriggerPrivatePanelOpen'
    ),
    isLiveStreaming: getLiveStreamData(state, [streamId], 'isLiveStreaming'),
    streamPreviewBlurDuration: +getRemoteConfigData(
      state,
      BLUROUT_PARAMETERS
    )?.[1],
    shouldDisplayBlurCountdown,
    hasStreamToken,
    hasGames: getRemoteConfigData(state, FEATURE_GAMES)?.length > 0,
    shouldUseLivestreamAlert: getOperationData(
      state,
      ['liveStream', 'chat', streamId],
      'shouldUseLivestreamAlert'
    ),
    toyCommandHintOpenedTimestamp: getOperationData(
      state,
      ['liveStream'],
      'toyCommandHintOpenedTimestamp'
    ),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    isKaraokeDeviceOnline: !!getLiveStreamData(state, [streamId], 'device'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    setGiftPanel: ({ isGiftPanelOpen }) =>
      dispatch(setLiveStreamPanel({ isGiftPanelOpen })),
    setChatPanel: ({ isChatPanelOpen }) =>
      dispatch(setLiveStreamPanel({ isChatPanelOpen })),
    setGamePanel: ({ isGamePanelOpen }) =>
      dispatch(setLiveStreamPanel({ isGamePanelOpen })),
    setTriggerPrivatePanel: ({ isTriggerPrivatePanelOpen }) =>
      dispatch(setLiveStreamPanel({ isTriggerPrivatePanelOpen })),
    toggleModal: data => dispatch(toggleModal(data)),
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
    checkLivestreamChatPreflightAndOpenPanel: ({ streamId }) =>
      dispatch(checkLivestreamChatPreflightAndOpenPanel({ streamId })),
    setToyCommandHintOpenedTimestamp: ({ toyCommandHintOpenedTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream'],
          data: {
            toyCommandHintOpenedTimestamp,
          },
        },
      }),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LivestreamDetailOnlineFooter)
);
